module.exports = __webpack_public_path__ + "static/media/galerija_2016 (7).54ca133f.jpg";